import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Notification, { notifyApiError } from "components/Notification";
import Layout from "layouts/DashboardManage";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import has from "lodash/has";
import { getClient } from "store/actions/clientAction";
import { SpinnerRainbow } from "components/Spinner";
import {
  getAllTeams,
  deleteTeam,
  resetPayload,
  DELETE_TEAM
} from "store/actions/teamAction";
import Translate from "helpers/Translate";
import NoData from "components/NoData";

export class Team extends Component {
  state = {
    showDeleteConfirm: false
  };

  componentDidMount() {
    this.props.getAllTeams({ clientId: this.props.match.params.clientId });
    this.props.getClient(this.props.match.params.clientId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      notifyApiError(this.props.error);
    }

    if (this.props.deleteStatus === 200) {
      Notification.success(Translate({ id: "data_deleted_successfully" }));
      this.props.resetPayload(DELETE_TEAM);
      this.props.getAllTeams({
        clientId: this.props.match.params.clientId,
        page: 1
      });
    }
  }

  handleDelete = (e, item) => {
    e.preventDefault();
    const id = e.currentTarget.id || item.id;
    Notification.confirm(
      Translate({ id: "sure_to_delete", values: [item.name] }),
      {
        onOk: () => {
          this.props.deleteTeam(id);
        }
      }
    );
  };

  onPageChange = targetPage => {
    this.props.getAllTeams({
      clientId: this.props.match.params.clientId,
      page: targetPage
    });
  };

  hasData = () => {
    return (
      !this.props.isLoading &&
      this.props.teams &&
      this.props.teams.data &&
      this.props.teams.data.length > 0
    );
  };

  render() {
    return (
      <Layout>
        <div className="manage">
          <Link className="back mb-20" to="/manage/clients">
            <i className="fas fa-long-arrow-alt-left"></i>{" "}
            {Translate({ id: "back_to_manage_clients" })}
          </Link>
          <h1 className="title mb-20">
            {Translate({ id: "manage_teams_for" })}&nbsp;
            <span className="client">
              {has(this, "props.client.data.name")
                ? this.props.client.data.name
                : "Loading..."}
            </span>
          </h1>
          <div className="manage-list-actions manage-list-actions--end">
            <Link
              data-test="btnadd"
              to={`/manage/clients/${this.props.match.params.clientId}/teams/add`}
              className="btn btn-primary btn-add-manage"
            >
              <i className="fas fa-plus mr-10"></i>
              {Translate({ id: "add_team" })}
            </Link>
          </div>

          {this.props.isLoading && <SpinnerRainbow />}

          {!this.props.isLoading && (
            <ManageDataTable
              footer={
                this.hasData() ? (
                  <Pagination
                    onPageChange={this.onPageChange}
                    data={this.props.teams && this.props.teams.meta}
                  />
                ) : null
              }
            >
              <table>
                <thead>
                  <tr>
                    <th className="left">{Translate({ id: "name" })} </th>
                    <th className="left">
                      {Translate({ id: "total_members" })}{" "}
                    </th>
                    <th className="left">{Translate({ id: "batch_size" })} </th>
                    <th className="action-col">
                      {Translate({ id: "action" })}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.hasData() &&
                    this.props.teams.data.map(item => (
                      <tr key={item.id}>
                        <td title={item.id}>{item.name}</td>
                        <td>{item.users.length}</td>
                        <td title={item.id}>{item.batch_size}</td>
                        <td className="action-col">
                          <div className="manage-data-table-actions">
                            <Link
                              className="action-btn action-edit"
                              title="Edit"
                              to={`/manage/clients/${this.props.match.params.clientId}/teams/edit/${item.id}`}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                            <button
                              type="button"
                              className="action-btn action-delete"
                              title={Translate({ id: "delete" })}
                              id={item.id}
                              onClick={e => this.handleDelete(e, item)}
                            >
                              <i className="fas fa-trash-alt" id={item.id}></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}

                  {!this.hasData() && (
                    <tr>
                      <td colSpan="100">
                        <NoData />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </ManageDataTable>
          )}
        </div>
      </Layout>
    );
  }
}

Team.propTypes = {
  getAllTeams: PropTypes.func.isRequired,
  teams: PropTypes.object,
  isLoading: PropTypes.bool,
  deleteStatus: PropTypes.number,
  error: PropTypes.object
};

const mapStateToProps = state => {
  return {
    teams: state.team.getAllTeams,
    client: state.client.getClient,
    isLoading: state.team.isLoadingTeam,
    deleteStatus: state.team.deleteTeamStatus,
    error: state.team.errorTeam
  };
};

export default connect(mapStateToProps, {
  getAllTeams,
  deleteTeam,
  getClient,
  resetPayload
})(Team);
